"use client";

import { User } from "lucide-react";
import Link from "@/components/ui/Link";
import { useUi } from "@/components/ui/use-ui";

export function SignInButton() {
  const t = useUi();
  return (
    <Link href="/login" aria-label={t.nav.logIn} title={t.nav.logIn} className="grid size-11 place-items-center rounded-full text-fg transition-colors hover:bg-white/10">
      <User size={24} strokeWidth={1.6} />
    </Link>
  );
}
